import {find, get, isNil, map, sortBy} from 'lodash';
import React from "react";
import {useTranslation} from "react-i18next";
import {useSetTranslation} from "common/useSetTranslation";
import SelectField from "components/redesign/SelectField";

const SingleSelectDropdown = ({DropDownItems, onAnswered, value, error, disabled = false}) => {
  const {t} = useTranslation();
  const {st} = useSetTranslation();

  const orderedOptionItems = sortBy(DropDownItems, option => option.displayOrder);

  const options = map(orderedOptionItems, option => ({
    key: option.key,
    label: st(option.displayName || option.label, option.localeLabel),
    helpText: option.helpText,
    disabled: option.isDisabled,
  }));

  // The answer is the option object the rest of the app stores, not its key.
  const handleChoice = key =>
    onAnswered(find(orderedOptionItems, option => option.key === key));

  return (
    <SelectField
      options={options}
      value={isNil(value) ? '' : get(value, 'key', '')}
      onChange={handleChoice}
      placeholder={t('selectCaps')}
      invalid={Boolean(error)}
      disabled={disabled}
    />
  );
};

export default SingleSelectDropdown;
